import fontResizer from "./common-components/fontResizer";
import pageLoader from "./common-components/pageLoader";
import landscapeOff from "./common-components/landscapeOff";
import stickyHeader from "./common-components/stickyHeader";
import svgConvert from "./common-components/svgConvert";
import navigationSlide from "./common-components/navigationSlide";
import navigationAccordion from "./common-components/navigationAccordion";
import animateObserver from "./common-components/animateObserver";
import lazyLoadImgObserver from "./common-components/lazyLoadImgObserver";
import clipPathImgObserver from "./common-components/clipPathImgObserver";
import desktopPanel from "./common-components/desktopPanel";
import footerAccordion from "./common-components/footerAccordion";
import whoWeAreSlider from "./components/home/whoWeAreSlider";
import tabLinks from "./components/news-detail/tabLinks"
import latestNewsSlider from "./components/home/latestNewsSlider"
import ourInnerSlider from "./components/strength-and-capability/ourInnerSlider";
import OurSectorSlider from "./components/home/ourSectorSlider"
import heroSectionSlider from "./components/strength-and-capability/heroSectionSlider";
import OneSideSlider from "./components/who-we-are/OneSlideSlider";
import counterNumber from "./common-components/counterNumbers"
import AccredidationSlider from "./components/who-we-are/AccreditationSlider";
import logoesSlider from "./components/home/logoesSlider";
import milestoneSlider from "./components/who-we-are/MilestoneSlider";
import Timeline from "./components/who-we-are/Timeline";
import heroFigure from "./components/hero-figure/index";
import socialMedia from "./components/social-media/index";
import modalPopup from "./components/meet-our-team/modalPopup";
import getTouchTabs from "./components/home/getTouchTabs";
import formFieldAnim from "./components/home/formFieldAnim";
import genericAccordion from "./common-components/genericAccordion";
import serviceCenteredSlider from "./components/service-detail/centered-slider";
import productCenteredSlider from "./components/project-detail/centered-slider";
import howWeDoProject from "./components/project-detail/single-slider";


landscapeOff();
stickyHeader();
svgConvert();
// navigationSlide();
navigationAccordion();
animateObserver();
lazyLoadImgObserver();
clipPathImgObserver();
footerAccordion();
desktopPanel();
formFieldAnim();
// -------------------- Above code might be common for all website --------------------------

// counterNumber();
whoWeAreSlider();
tabLinks();
latestNewsSlider();
OurSectorSlider();
ourInnerSlider();
heroSectionSlider();
OneSideSlider();
AccredidationSlider();
milestoneSlider()
logoesSlider();
Timeline();
heroFigure();
socialMedia();
modalPopup();
getTouchTabs();
genericAccordion();
serviceCenteredSlider();
productCenteredSlider();
howWeDoProject();


